import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { formatApiErrorDetail } from '../../lib/adminApi';
import { ADMIN_LOGIN } from '../../constants/testIds';

const AdminLogin = () => {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-10">
          <span className="w-12 h-12 rounded-xl bg-[#F97316] flex items-center justify-center shadow-sm">
            <MapPin size={24} className="text-white" strokeWidth={2.5} />
          </span>
          <span className="text-[30px] font-extrabold tracking-tight text-white" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Ambanji <span className="text-stone-500 font-semibold">Admin</span>
          </span>
        </div>

        <form onSubmit={handleSubmit} className="bg-stone-900 border border-stone-800 rounded-2xl p-9 space-y-6">
          <div>
            <label className="block text-sm font-semibold text-stone-400 mb-2">Email</label>
            <input
              data-testid={ADMIN_LOGIN.emailInput}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-5 py-4 rounded-xl bg-stone-950 border border-stone-700 text-white text-lg focus:outline-none focus:ring-2 focus:ring-[#F97316]"
              placeholder="owner@ambanji.com"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-stone-400 mb-2">Password</label>
            <input
              data-testid={ADMIN_LOGIN.passwordInput}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-5 py-4 rounded-xl bg-stone-950 border border-stone-700 text-white text-lg focus:outline-none focus:ring-2 focus:ring-[#F97316]"
              placeholder="••••••••••"
            />
          </div>

          {error && (
            <p data-testid={ADMIN_LOGIN.errorMessage} className="text-base text-red-400 bg-red-950/50 border border-red-900 rounded-xl px-4 py-3">
              {error}
            </p>
          )}

          <button
            data-testid={ADMIN_LOGIN.submitButton}
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-xl bg-[#F97316] text-white text-lg font-bold hover:bg-[#EA580C] transition disabled:opacity-60"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="text-center text-stone-600 text-sm mt-7">Owner access only — not for clients.</p>
      </div>
    </div>
  );
};

export default AdminLogin;
